import type { FlaggedContentStatus, FlaggedContentType } from "@/models"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

export interface IContentFlagReviewRequest {
  contentType: FlaggedContentType
  contentId: number
  status: FlaggedContentStatus
  reviewNotes?: string
}

interface IUsePostFlaggedContentReviewArgs {
  eventVaultId: number
  reviewRequest: IContentFlagReviewRequest
}

export async function reviewFlaggedContent(eventVaultId: number, reviewRequest?: IContentFlagReviewRequest) {
  const response = await v1.put(`/${eventVaultId}/moderate/flagged-content/review`, reviewRequest)

  return response.data.message
}

const REVIEW_FLAGGED_CONTENT_KEY = "reviewFlaggedContent"

export function useReviewFlaggedContent() {
  return useMutation({
    mutationKey: [REVIEW_FLAGGED_CONTENT_KEY],
    mutationFn: ({ eventVaultId, reviewRequest }: IUsePostFlaggedContentReviewArgs) =>
      reviewFlaggedContent(eventVaultId, reviewRequest),
  })
}
